/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentMethodOverridableConfiguration } from './PaymentMethodOverridableConfiguration';
import {
    PaymentMethodOverridableConfigurationFromJSON,
    PaymentMethodOverridableConfigurationFromJSONTyped,
    PaymentMethodOverridableConfigurationToJSON,
    PaymentMethodOverridableConfigurationToJSONTyped,
} from './PaymentMethodOverridableConfiguration';

/**
 * 
 * @export
 * @interface PaymentMethodConfiguration
 */
export interface PaymentMethodConfiguration {
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethodConfiguration
     */
    visibleInApps: boolean;
    /**
     * 
     * @type {PaymentMethodOverridableConfiguration}
     * @memberof PaymentMethodConfiguration
     */
    overridableConfiguration: PaymentMethodOverridableConfiguration;
}

/**
 * Check if a given object implements the PaymentMethodConfiguration interface.
 */
export function instanceOfPaymentMethodConfiguration(value: object): value is PaymentMethodConfiguration {
    if (!('visibleInApps' in value) || value['visibleInApps'] === undefined) return false;
    if (!('overridableConfiguration' in value) || value['overridableConfiguration'] === undefined) return false;
    return true;
}

export function PaymentMethodConfigurationFromJSON(json: any): PaymentMethodConfiguration {
    return PaymentMethodConfigurationFromJSONTyped(json, false);
}

export function PaymentMethodConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMethodConfiguration {
    if (json == null) {
        return json;
    }
    return {
        
        'visibleInApps': json['visibleInApps'],
        'overridableConfiguration': PaymentMethodOverridableConfigurationFromJSON(json['overridableConfiguration']),
    };
}

export function PaymentMethodConfigurationToJSON(json: any): PaymentMethodConfiguration {
    return PaymentMethodConfigurationToJSONTyped(json, false);
}

export function PaymentMethodConfigurationToJSONTyped(value?: PaymentMethodConfiguration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'visibleInApps': value['visibleInApps'],
        'overridableConfiguration': PaymentMethodOverridableConfigurationToJSON(value['overridableConfiguration']),
    };
}

